import React, { useState } from 'react';
import PropTypes from 'prop-types';

import AddControl from 'components/add_control';
import VendorRelationTable from './vendor_relation_table';

export default function QuickbooksUserVendorTable({ users, vendorsById = {} }) {
  const showTableByDefault = users.some(u => u.quickbooksId);
  const [showTable, setShowTable] = useState(showTableByDefault);

  if (users.length === 0) {
    return null;
  }

  if (!showTable) {
    return (
      <AddControl id="add-vendor-associations" onClick={() => setShowTable(true)}>
        Add Associations
      </AddControl>
    );
  }

  return (<VendorRelationTable relationType="User" showAll={false} users={users} vendorsById={vendorsById} />);
}

QuickbooksUserVendorTable.propTypes = {
  users: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    quickbooksId: PropTypes.number,
  })).isRequired,
  vendorsById: PropTypes.objectOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    displayName: PropTypes.string,
  })),
};
